'use client'

import { type MouseEvent, type PointerEvent, useEffect } from 'react'

import { ACCOUNT_MENU_ID } from '../../constants/accountMenuIds'
import { useAccountMenu } from '../../hooks/useAccountMenu'

import styles from './WrapperAccountMenu.module.scss'

type WrapperAccountMenuProps = {
	readonly refAccountMenu: React.RefObject<HTMLDivElement>
	readonly children: React.ReactNode
}

export function WrapperAccountMenu({
	refAccountMenu,
	children,
}: WrapperAccountMenuProps) {
	const { open, close } = useAccountMenu()

	useEffect(() => {
		const handlerBlur = (event: FocusEvent) => {
			const { relatedTarget } = event
			const { current } = refAccountMenu

			if (!current || current?.contains(relatedTarget as Node)) {
				return
			}

			close()
		}

		refAccountMenu.current?.addEventListener('focusout', handlerBlur)

		return () => {
			refAccountMenu.current?.removeEventListener('focusout', handlerBlur)
		}
	}, [])

	const handleClose = (event: MouseEvent | PointerEvent) => {
		const { target } = event
		const { current } = refAccountMenu

		if (!current) {
			return
		}

		const currenTarget = current?.contains(target as Node)

		if (!currenTarget) {
			close()
		}
	}

	return (
		<div
			id={ACCOUNT_MENU_ID}
			className={styles.wrapperAccountMenu}
			ref={refAccountMenu}
			onMouseOutCapture={(event) => handleClose(event)}
			onPointerEnter={open}
			onPointerLeave={close}
			data-testid='header.accountMenu.wrapper'
		>
			{children}
		</div>
	)
}
